<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 감정평가사 ? 노무사 신규 론칭…”전문직 자격증 시장에서도 우위 잡을 것”</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_11.png"></figure>
                                <br>
                                <br>
                              종합교육기업 에듀윌이 전문직 자격증 시험 중 하나인 감정평가사와 노무사 교육 과정을 신규 론칭했다고 12일 밝혔다.
                              <br><br>
                              지난 2021년 세무사 론칭을 시작으로 올해 감정평가사와 노무사 교육 과정까지 론칭하며 전문직 자격증 수요를 견인해 나갈 계획이다. 관련 업계에 따르면, 직업의 안정성을 중시하는 사회적 분위기가 형성되면서 매년 전문직 자격증 시험에 많은 수험생들이 몰리고 있다.
                                <br><br>
                              실제로 세무사와 회계사 시험은 물론 올해 감정평가사와 노무사 1차시험 접수자 규모는 역대 최고치를 기록했다. 감정평가사는 전년대비 43.8%, 노무사는 23.8% 증가했으며, 5년 전과 비교하면 각각 3.8배 그리고 2.2배나 그 규모가 늘었다.
                                <br><br>
                              에듀윌이 공식 론칭을 한 달 앞두고 진행한 얼리버드 할인 이벤트에서도 특가 상품에 많은 수험생들이 몰리며 감정평가사와 노무사 시험에 대한 인기를 실감할 수 있었다.
                              <br><br>
                              에듀윌은 이번 공식 론칭을 기념해 다양한 혜택을 마련했다. 초시생을 위해 자체 제작한 노무사 및 감정평가사 초보 수험가이드와 필수이론 강의로 구성된 입문 패키지를 무료로 증정한다. 타사 수강생 또는 재도전 수험생을 위해서는 수강료를 최대 60% 할인해주고, 수강 패스 또한 보다 할인된 가격으로 내놨다.
                                <br><br>
                              에듀윌 관계자는 “감정평가사와 노무사 자격시험에 대한 응시 수요가 향후 더욱 늘 것으로 내다보고 이번 과정을 신규 론칭하게 됐다”면서, “그간의 합격 노하우를 토대로 감정평가사와 노무사 등 전문직 자격증 교육시장에서도 우위를 선점해 나갈 것”이라고 말했다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news12" data-value="315283">
                                        <strong>이전</strong>
                                        <span>'에듀윌 공인중개사 합격서', 판매 즉시 온라인서점 국내도서 전체 베스트셀러 올라</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news10" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌-육군본부, 육군 장병 취업역량 강화 '맞손'</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
